import { Routes } from '@angular/router';
import { authRoutes } from './features/auth/auth.routes';
import { APP_PATHS } from './shared/constants/routes.constants';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/landing-page/landing-page').then((m) => m.LandingPage),
  },
  {
    path: APP_PATHS.RESET_PASSWORD,
    pathMatch: 'full',
    redirectTo: `${APP_PATHS.AUTH}/${APP_PATHS.RESET_PASSWORD}`,
  },
  ...authRoutes,
  {
    path: '',
    loadComponent: () =>
      import('./features/pages/main-layout/main-layout.component').then(
        (m) => m.MainLayoutComponent,
      ),
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/pages/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
